import { $, $$, on, doc } from './util.js';

/* 5. DOCS SIDEBAR TREE (collapse groups, mobile toggle) */
export function initSidebar() {
	$$('.sb-toggle').forEach(function (btn) {
		on(btn, 'click', function () {
			var open = btn.getAttribute('aria-expanded') === 'true';
			var group = doc.getElementById(btn.getAttribute('aria-controls'));
			btn.setAttribute('aria-expanded', open ? 'false' : 'true');
			if (group) { group.hidden = open; }
		});
	});

	var toggle = $('#sbMobileToggle');
	var sidebar = $('#docsSidebar');
	if (toggle && sidebar) {
		// Collapsed by default on small screens; the media query shows the button.
		// Guarded the way theme.js guards its own call: an unguarded
		// window.matchMedia(...) throws where the API is absent, and because
		// boot() used to run the features in one unprotected sequence, that one
		// throw took out every feature listed after this one.
		if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) { sidebar.hidden = true; }
		on(toggle, 'click', function () {
			sidebar.hidden = !sidebar.hidden;
			toggle.setAttribute('aria-expanded', sidebar.hidden ? 'false' : 'true');
		});
	}
}
